import { createAsyncThunk, createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { ntxAPI } from '@API/axiosNeatex';
import type { PurchasesReturnsModels } from './Models';

export const addReturnsPurchaseOrder = createAsyncThunk(
  'ReturnsPurchaseOrder/addReturnsPurchaseOrder',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('ReturnsPurchaseOrder/Add', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateReturnsPurchaseOrder = createAsyncThunk(
  'ReturnsPurchaseOrder/updateReturnsPurchaseOrder',
  async (item: any, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post('ReturnsPurchaseOrder/Update', item);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnsPurchaseOrderList = createAsyncThunk(
  'ReturnsPurchaseOrder/getReturnsPurchaseOrderList',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get('ReturnsPurchaseOrder/GetList');
      if (data?.succeeded) {
        return data.data;
      } else {
        return rejectWithValue(data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnsPurchaseOrderById = createAsyncThunk(
  'ReturnsPurchaseOrder/getReturnsPurchaseOrderById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`ReturnsPurchaseOrder/GetById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getDetailsById = createAsyncThunk(
  'ReturnsPurchaseOrder/getDetailsById',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`ReturnsPurchaseOrder/GetDetailsById?Id=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const getReturnsPurchaseOrderByPurchasesOrderId = createAsyncThunk(
  'ReturnsPurchaseOrder/getReturnsPurchaseOrderByPurchasesOrderId',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.get(`ReturnsPurchaseOrder/GetByPurchasesOrderId?PurchasesOrderId=${id}`);
      if (data?.succeeded) {
        // ===
        return data.data;
      } else {
        return rejectWithValue(data?.message || 'هناك خطأ');
      }
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

export const DeleteReturnsPurchaseOrder = createAsyncThunk(
  'ReturnsPurchaseOrder/DeleteReturnsPurchaseOrder',
  async (id: string, { rejectWithValue }) => {
    try {
      const { data } = await ntxAPI.post(`ReturnsPurchaseOrder/Delete?Id=${id}`);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.message);
    }
  }
);

const initialState: {
  PurchaseReturnList: PurchasesReturnsModels[];
  PurchaseReturnById: PurchasesReturnsModels;
  loading: boolean;
  error: any | null;
  //
  DetailsById: PurchasesReturnsModels;
  loading2: boolean;
  error2: any | null;
} = {
  PurchaseReturnList: [],
  PurchaseReturnById: {} as PurchasesReturnsModels,
  loading: false,
  error: null,
  //

  DetailsById: {} as PurchasesReturnsModels,
  loading2: false,
  error2: null
};

const PurchaseReturnSlice = createSlice({
  name: 'ReturnsPurchaseOrder',
  initialState,
  reducers: {
    cleanUpPurchasesReturnsById: state => {
      state.PurchaseReturnById = {} as PurchasesReturnsModels;
    },
    cleanUpDetailsById: state => {
      state.DetailsById = {} as PurchasesReturnsModels;
    }
  },
  extraReducers(builder) {
    builder

      .addCase(getReturnsPurchaseOrderList.pending, state => {
        state.loading = true;
      })
      .addCase(getReturnsPurchaseOrderList.fulfilled, (state, action: PayloadAction<PurchasesReturnsModels[]>) => {
        state.loading = false;
        state.PurchaseReturnList = action.payload;
      })
      .addCase(getReturnsPurchaseOrderList.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(getReturnsPurchaseOrderById.pending, state => {
        state.loading = true;
      })
      .addCase(getReturnsPurchaseOrderById.fulfilled, (state, action: PayloadAction<PurchasesReturnsModels>) => {
        state.loading = false;
        state.PurchaseReturnById = action.payload;
      })
      .addCase(getReturnsPurchaseOrderById.rejected, (state, action: PayloadAction<any>) => {
        state.loading = false;
        state.error = action.payload;
      })
      //////////////////
      .addCase(getDetailsById.pending, state => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(getDetailsById.fulfilled, (state, action: PayloadAction<PurchasesReturnsModels>) => {
        state.loading2 = false;
        state.DetailsById = action.payload;
      })
      .addCase(getDetailsById.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      })
      ////////////////////
      .addCase(getReturnsPurchaseOrderByPurchasesOrderId.pending, state => {
        state.loading2 = true;
        state.error2 = null;
      })
      .addCase(
        getReturnsPurchaseOrderByPurchasesOrderId.fulfilled,
        (state, action: PayloadAction<PurchasesReturnsModels>) => {
          state.loading2 = false;
          // state.PurchaseReturnById = action.payload;
          state.DetailsById = action.payload;
        }
      )
      .addCase(getReturnsPurchaseOrderByPurchasesOrderId.rejected, (state, action: PayloadAction<any>) => {
        state.loading2 = false;
        state.error2 = action.payload;
      });
  }
});

export const { cleanUpPurchasesReturnsById, cleanUpDetailsById } = PurchaseReturnSlice.actions;
export default PurchaseReturnSlice.reducer;
